import AllCampaignsQuery from '@/graphql/campaign/AllCampaignsQuery.gql'
import CampaignRejectReasonsQuery from '@/graphql/campaign/CampaignRejectReasonsQuery.gql'
import CampaignsQuery from '@/graphql/campaign/CampaignsQuery.gql'
import ReviewCampaign from '@/graphql/campaign/ReviewCampaign.gql'
import UnreviewedCampaignsQuery from '@/graphql/campaign/UnreviewedCampaignsQuery.gql'

import apollo from '@/graphql'

// initial state
const state = {
  allCampaigns: [],
  campaignRejectReasons: [],
  campaigns: [],
  isLoadingCampaigns: false,
  isLoadingAllCampaigns: false,
  unreviewedCampaigns: [],
}

// getters
const getters = {
  campaigns(state) {
    return state.campaigns.map(campaign => (
      {
        campaignTypesId: campaign.campaignTypesId,
        endTs: +campaign.endDate,
        id: campaign.id,
        startTs: +campaign.startDate,
        status: campaign.status,
        stores: campaign.activeSummary,
        title: campaign.name,
        tmpVideo: campaign.tmpVideo,
        videosId: campaign.videosId,
      }))
  },
}

const mutations = {
  initializeStore() {
    state.campaigns = []
  },

  setAllCampaigns(state, allCampaigns) {
    state.allCampaigns = allCampaigns
  },

  setCampaignRejectReasons(state, campaignRejectReasons) {
    state.campaignRejectReasons = campaignRejectReasons
  },

  setCampaigns(state, campaigns) {
    state.campaigns = campaigns
  },

  setUnreviewedCampaigns(state, unreviewedCampaigns) {
    state.unreviewedCampaigns = unreviewedCampaigns
  },

  setIsLoadingCampaigns(state, isLoadingCampaigns) {
    state.isLoadingCampaigns = isLoadingCampaigns
  },

  setIsLoadingAllCampaigns(state, isLoadingAllCampaigns) {
    state.isLoadingAllCampaigns = isLoadingAllCampaigns
  },
}

// actions
const actions = {
  init({ commit }) {
    commit('initializeStore')
  },

  loadAllCampaigns({ commit }) {
    commit('setIsLoadingAllCampaigns', true)
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        query: AllCampaignsQuery,
      })
      .subscribe(({ data: { allCampaigns } }) => {
        commit('setAllCampaigns', allCampaigns)
        commit('setIsLoadingAllCampaigns', false)
      })
  },

  loadCampaignRejectReasons({ commit }) {
    apollo.defaultClient
      .watchQuery({
        query: CampaignRejectReasonsQuery,
      })
      .subscribe(({ data: { campaignRejectReasons } }) => {
        commit('setCampaignRejectReasons', campaignRejectReasons)
      })
  },

  async loadCampaigns({ commit }) {
    commit('setIsLoadingCampaigns', true)

    const { data: { campaigns } } = await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: CampaignsQuery,
        variables: { companiesId: this.getters['Auth/user'].companiesId },
      })
      .catch(() => {
        commit('setIsLoadingCampaigns', false)
        commit('setCampaigns', [])
      })

    // End date is saved as original selected date at 8am UTC + 1 day
    // so that the campaign plays through the end date. Subtract out
    // this value when displaying to the user.

    // TODO: Debug
    // campaigns.forEach((c) => {
    //   // eslint-disable-next-line no-param-reassign
    //   c.endDate = +c.endDate - 86400000
    // })

    commit('setCampaigns', campaigns)
    commit('setIsLoadingCampaigns', false)
  },

  loadUnreviewedCampaigns({ commit }) {
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        query: UnreviewedCampaignsQuery,
      })
      .subscribe(({ data: { unreviewedCampaigns } }) => {
        commit('setUnreviewedCampaigns', unreviewedCampaigns)
      })
  },

  reviewCampaign(context, {
    id, isApproved, contentRejectReasonsId,
  }) {
    apollo.defaultClient.mutate({
      mutation: ReviewCampaign,
      variables: {
        id,
        isApproved,
        campaignRejectReasonsId: contentRejectReasonsId,
      },
      refetchQueries: [
        {
          query: UnreviewedCampaignsQuery,
        },
      ],
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/campaign/CampaignList.js